// Tidy Sheets basket suggestions: one-click "Add" and "Swap for the bundle" buttons.
// Uses event delegation so it keeps working after the basket re-renders.
import { CartLinesUpdateEvent } from '@shopify/events';

const routes = () => (window.Theme && window.Theme.routes) || {};

const sectionIds = () => [
  ...new Set(
    [...document.querySelectorAll('cart-items-component')]
      .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
      .filter(Boolean)
  ),
];

const postJson = async (url, body) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.status) throw new Error(data.description || data.message || 'Basket update failed');
  return data;
};

const setStatus = (button, text) => {
  const status = button.closest('[data-tcs]')?.querySelector('[data-tcs-status]');
  if (status) status.textContent = text;
};

async function changeBasket(button) {
  if (button.disabled) return;
  const variantId = button.dataset.variant;
  if (!variantId) return;
  const removeKeys = (button.dataset.remove || '').split(',').filter(Boolean);
  const ids = sectionIds();

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  setStatus(button, '');

  let deferred = null;
  try {
    deferred = CartLinesUpdateEvent.createPromise();
    button.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: deferred.promise,
      })
    );
  } catch (error) {
    console.warn('[tidy-cart-suggestions] could not announce the basket change', error);
    deferred = null;
  }

  try {
    const base = { sections: ids.join(','), sections_url: window.location.pathname };
    let result;
    if (removeKeys.length) {
      // Swap: take the single templates out and put the bundle in, in one request.
      const updates = {};
      removeKeys.forEach((key) => {
        updates[key] = 0;
      });
      updates[variantId] = 1;
      result = await postJson(`${routes().cart_update_url || '/cart/update'}.js`, { updates, ...base });
    } else {
      result = await postJson(routes().cart_add_url || '/cart/add.js', {
        items: [{ id: Number(variantId), quantity: 1 }],
        ...base,
      });
    }

    const cartResponse = await fetch(`${routes().cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    const cart = await cartResponse.json();

    if (deferred) {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'tidy-cart-suggestions',
          itemCount: 1,
          sections: result.sections,
          didError: false,
        },
      });
    } else {
      window.location.reload();
    }
  } catch (error) {
    console.warn('[tidy-cart-suggestions]', error);
    if (deferred) deferred.reject(Object.assign(new Error('Basket update failed'), { name: 'AbortError' }));
    button.disabled = false;
    button.removeAttribute('aria-busy');
    setStatus(button, 'Sorry, that did not work. Please try again.');
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const button = target?.closest('[data-tcs-add], [data-tcs-swap]');
  if (!(button instanceof HTMLButtonElement)) return;
  event.preventDefault();
  changeBasket(button);
});
